import React from 'react';
import { Facebook, Share2, Twitter, Link as LinkIcon, Check } from 'lucide-react';

interface ShareButtonsProps {
  url: string;
  title: string;
  description?: string;
  className?: string;
}

export function ShareButtons({ url, title, description, className = '' }: ShareButtonsProps) {
  const [copied, setCopied] = React.useState(false);
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
  // X/Twitter (z tytułem)
  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;

  const handleWebShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: description || title,
          url
        });
      } catch (e) {
        // użytkownik mógł anulować — brak akcji
      }
    } else {
      window.open(facebookUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // w razie braku zgody przeglądarki
    }
  };

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <a
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-accessible-gray-200 dark:border-accessible-gray-700 bg-white/80 dark:bg-accessible-gray-800/60 high-contrast:bg-white/10 hover:bg-accessible-red-600/10 hover:border-accessible-red-600/40 text-accessible-gray-600 dark:text-accessible-gray-300 hover:text-accessible-red-600 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accessible-red-600/50 active:scale-[0.98] tap-target"
        aria-label="Udostępnij na Facebooku"
        title="Udostępnij na Facebooku"
      >
        <Facebook className="w-5 h-5" />
        <span className="sr-only">Facebook</span>
      </a>

      <a
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-accessible-gray-200 dark:border-accessible-gray-700 bg-white/80 dark:bg-accessible-gray-800/60 high-contrast:bg-white/10 hover:bg-accessible-red-600/10 hover:border-accessible-red-600/40 text-accessible-gray-600 dark:text-accessible-gray-300 hover:text-accessible-red-600 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accessible-red-600/50 active:scale-[0.98] tap-target"
        aria-label="Udostępnij na X (Twitter)"
        title="Udostępnij na X (Twitter)"
      >
        <Twitter className="w-5 h-5" />
        <span className="sr-only">X</span>
      </a>

      <button
        onClick={handleWebShare}
        className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-accessible-gray-200 dark:border-accessible-gray-700 bg-white/80 dark:bg-accessible-gray-800/60 high-contrast:bg-white/10 hover:bg-accessible-red-600/10 hover:border-accessible-red-600/40 text-accessible-gray-600 dark:text-accessible-gray-300 hover:text-accessible-red-600 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accessible-red-600/50 active:scale-[0.98] tap-target"
        aria-label="Udostępnij"
        title="Udostępnij"
      >
        <Share2 className="w-5 h-5" />
        <span className="sr-only">Udostępnij</span>
      </button>

      <button
        onClick={handleCopy}
        className="inline-flex items-center justify-center w-11 h-11 rounded-full border border-accessible-gray-200 dark:border-accessible-gray-700 bg-white/80 dark:bg-accessible-gray-800/60 high-contrast:bg-white/10 hover:bg-accessible-red-600/10 hover:border-accessible-red-600/40 text-accessible-gray-600 dark:text-accessible-gray-300 hover:text-accessible-red-600 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accessible-red-600/50 active:scale-[0.98] tap-target"
        aria-label="Skopiuj link"
        title="Skopiuj link"
      >
        {copied ? <Check className="w-5 h-5" /> : <LinkIcon className="w-5 h-5" />}
        <span className="sr-only">{copied ? 'Skopiowano' : 'Kopiuj link'}</span>
      </button>
    </div>
  );
}

export default ShareButtons;


